import React from 'react'
import './PageNav.scss'
import { NavLink } from 'react-router-dom'
import { PagesType } from '../PageRoutes'

export const PageNav = ({ pages }: { pages: PagesType[] }) => (
  <nav className="PageNav">
    {pages.map((page) => (
      <NavLink
        key={page.path}
        className="PageNav__nav-link"
        activeClassName="PageNav__nav-link--active"
        to={page.path}
        exact={page.exactPath}
      >
        {page.title}
      </NavLink>
    ))}
  </nav>
)
